var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0H6C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48H43C46.3137 48 49 45.3137 49 42V6C49 2.68629 46.3137 0 43 0Z",
    fill: "#176B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 32.375H30.8125V34.25H17.6875V32.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 28.375H30.8125V30.25H17.6875V28.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 22.375H30.8125V24.25H26.4375V22.375Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 18.375H30.8125V20.25H26.4375V18.375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3501 24.001H18.6881V22.126H21.3501C21.5573 22.126 21.7559 22.0437 21.9024 21.8972C22.0489 21.7507 22.1311 21.5521 22.1311 21.345C22.1311 21.1378 22.0489 20.9392 21.9024 20.7927C21.7559 20.6462 21.5573 20.564 21.3501 20.564H20.4001C19.6957 20.564 19.0202 20.2841 18.5221 19.786C18.024 19.2879 17.7441 18.6124 17.7441 17.908C17.7441 17.2035 18.024 16.528 18.5221 16.0299C19.0202 15.5318 19.6957 15.252 20.4001 15.252H23.0631V17.127H20.4001C20.1929 17.127 19.9941 17.2093 19.8475 17.3558C19.701 17.5024 19.6186 17.7012 19.6186 17.9085C19.6186 18.1157 19.701 18.3145 19.8475 18.4611C19.9941 18.6076 20.1929 18.69 20.4001 18.69H21.3501C22.0547 18.69 22.7304 18.9698 23.2286 19.468C23.7268 19.9662 24.0066 20.6419 24.0066 21.3465C24.0066 22.051 23.7268 22.7267 23.2286 23.2249C22.7304 23.7231 22.0547 24.003 21.3501 24.003V24.001Z",
    fill: "#61CE65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 14.313H21.8125V16.188H19.9375V14.313Z",
    fill: "#61CE65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 23.063H21.8125V24.938H19.9375V23.063Z",
    fill: "#61CE65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.063 39H16.438C15.5265 38.9995 14.6525 38.6372 14.0079 37.9928C13.3633 37.3484 13.0008 36.4745 13 35.563V12.438C13.0005 11.5263 13.3629 10.6522 14.0076 10.0076C14.6522 9.36292 15.5263 9.00053 16.438 9H32.063C32.9745 9.00079 33.8484 9.3633 34.4928 10.0079C35.1372 10.6525 35.4995 11.5265 35.5 12.438V35.563C35.4992 36.4743 35.1368 37.3481 34.4924 37.9924C33.8481 38.6368 32.9743 38.9992 32.063 39ZM16.438 10.875C16.0238 10.8758 15.6268 11.0408 15.334 11.3337C15.0412 11.6267 14.8765 12.0238 14.876 12.438V35.563C14.8765 35.9774 15.0414 36.3746 15.3344 36.6676C15.6274 36.9606 16.0246 37.1255 16.439 37.126H32.063C32.4772 37.1255 32.8743 36.9608 33.1673 36.668C33.4602 36.3752 33.6252 35.9782 33.626 35.564V12.438C33.6252 12.024 33.4604 11.6271 33.1676 11.3344C32.8749 11.0416 32.478 10.8768 32.064 10.876L16.438 10.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListB);
export default __webpack_public_path__ + "static/media/list-b.525752bf01ffb0c4a8a25a54e080b007.svg";
export { ForwardRef as ReactComponent };